export const createDogFormData = (userId, data, userData) => {
  const formData = new FormData();

  const isTeamSocial =
    userData.team_social !== undefined
      ? userData.team_social
      : userData.team === "social";

  const isTeamPaws =
    userData.team_paws !== undefined
      ? userData.team_paws
      : userData.team === "paws";

  formData.append("user_id", userId || "");
  formData.append("dog_name", data.dogName || "");

  let gender = data.dogGender || "";
  if (gender.toLowerCase() === "boy") gender = "Male";
  else if (gender.toLowerCase() === "girl") gender = "Female";
  formData.append("dog_gender", gender);

  formData.append("dog_breed", data.dogBreed || "");
  formData.append("dog_activity", data.dogActivity || "");
  formData.append("bio", data.dogBio || "");

  if (data.dogAgeGroup) {
    formData.append("age_group", data.dogAgeGroup);
    formData.append("dog_birthday", "");
  } else if (data.dogBirthDate) {
    formData.append("age_group", "");
    formData.append("dog_birthday", data.dogBirthDate);
  } else {
    formData.append("age_group", "");
    formData.append("dog_birthday", "");
  }

  const isMixed =
    data.dogBreed && data.dogBreed.toLowerCase().includes("mixed");
  if (isMixed) {
    const mixedBreeds = [
      data.selectedBreed1,
      data.selectedBreed2,
      data.selectedBreed3,
    ].filter((item) => item && item.trim() !== "");
    formData.append("dog_mixedBreed", JSON.stringify(mixedBreeds));
  } else {
    formData.append("dog_mixedBreed", JSON.stringify([]));
  }

  if (isTeamSocial) {
    formData.append(
      "past_experience_with_dogs",
      userData.pastExperienceLevelWithDogs?.label || "",
    );

    const personalityCheckArray = userData.pawsonalityAnswers
      ? Object.values(userData.pawsonalityAnswers)
          .filter(
            (item) => item && typeof item === "string" && item.trim() !== "",
          )
          .map((item) => item.trim())
      : [];

    formData.append("pawsonality_check", JSON.stringify(personalityCheckArray));
  } else {
    formData.append("past_experience_with_dogs", "");
    formData.append("pawsonality_check", JSON.stringify([]));
  }

  const personalityArray = data.dogPersonality
    ? Object.values(data.dogPersonality).filter(
        (item) => item && item.trim() !== "",
      )
    : [];
  formData.append("personality", JSON.stringify(personalityArray));

  formData.append("dog_traits", JSON.stringify(data.selectedTraits || []));
  formData.append("dog_hobbies", JSON.stringify(data.selectedHobbies || []));
  formData.append("availability", JSON.stringify(data.availability || []));

  // Resumed onboarding can supply the API's JSON string instead of an array.
  let bringsYouHere = userData.selectedBringsYouHere || [];
  if (typeof bringsYouHere === "string") {
    try {
      bringsYouHere = JSON.parse(bringsYouHere);
    } catch {
      bringsYouHere = [bringsYouHere];
    }
  }
  if (!Array.isArray(bringsYouHere)) {
    bringsYouHere = typeof bringsYouHere === "string" ? [bringsYouHere] : [];
  }
  const cleanBringsYouHere = bringsYouHere.filter(
    (item) =>
      typeof item === "string" &&
      item.trim() !== "" &&
      item.trim() !== "[" &&
      item.trim() !== "]",
  );
  formData.append("brings_you_here", JSON.stringify(cleanBringsYouHere));

  formData.append(
    "along_with_other_dogs",
    data.socialExperienceLevelWithDogs?.label || "",
  );
  formData.append(
    "along_with_other_humans",
    data.socialExperienceWithHumans?.label || "",
  );

  formData.append("team_social", isTeamSocial);
  formData.append("team_paws", isTeamPaws);
  formData.append(
    "isDogProfileComplete",
    userData.isDogProfileComplete !== undefined
      ? userData.isDogProfileComplete
      : false,
  );
  formData.append(
    "isDogProfileHalfComplete",
    userData.isDogProfileHalfComplete !== undefined
      ? userData.isDogProfileHalfComplete
      : false,
  );

  const appendFileOnly = (fieldName, fileObj) => {
    if (fileObj && (fileObj instanceof File || fileObj instanceof Blob)) {
      formData.append(fieldName, fileObj);
    }
  };

  if (userData.photos) {
    appendFileOnly("profile_image", userData.photos.main);
    appendFileOnly("profile_image", userData.photos.sub1);
    appendFileOnly("profile_image", userData.photos.sub2);
    appendFileOnly("profile_image", userData.photos.sub3);
  }

  if (data.dogPhotos) {
    appendFileOnly("dog_images", data.dogPhotos.main);
    appendFileOnly("dog_images", data.dogPhotos.sub1);
    appendFileOnly("dog_images", data.dogPhotos.sub2);
    appendFileOnly("dog_images", data.dogPhotos.sub3);
  }

  return formData;
};
